import React, { useState } from 'react';
import Select from 'react-select'
import makeAnimated from 'react-select/animated';
import { Blackcurrant, Citrus, Orange, Strawberry, Cola, Pineapple, Original, Peach, Apple, Watermelon, Yes, No, UpArrow, LittleArrow, Information } from '../icons/Icons';
import Modal from 'react-modal';
import vitaminOptions from '../../../../src/js/global/vitaminOptions';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    width: '90%',
    padding: '40px 20px',
    maxWidth: '500px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
  }
};

const closeButton = {
  width: '30px',
}

Modal.setAppElement('#root');


const animatedComponents = makeAnimated();

const PageFive = (props) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [maxVitamins, setMaxVitamins] = useState(0);
  const [flavoursHidden, setFlavoursHidden] = useState(true);

  let vitOptions = vitaminOptions;

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function updateVitaminValues(vitamins) {

    // loop through vitamins and see if inositol or vegan-vitamin-d3 is selected
    // if so, update vitOptions by removing 'disabled: true' from inositol-2 vegan-vitamin-d3-2 respectively
    for (let i = 0; i < vitamins.length; i++) {
      if (vitamins[i].value == "inositol") {
        for (let j = 0; j < vitOptions.length; j++) {
          if (vitOptions[j].value == "inositol-2") {
            vitOptions[j].disabled = false;
          }
        }
      }
      if (vitamins[i].value == "vegan-vitamin-d3") {
        for (let j = 0; j < vitOptions.length; j++) {
          if (vitOptions[j].value == "vegan-vitamin-d3-2") {
            vitOptions[j].disabled = false;
          }
        }
      }
    }

    setMaxVitamins(vitamins.length);
    props.setSelectedVitamins(vitamins);
    props.updateQuestionUrl(`selected-${vitamins.length}`);
  }

  // If the user is pregnant,
  // remove Vitamin A and 5-HTP as options for them to select
  if (props.natalAnswerIndex.length === 0 || props.natalAnswerIndex[0] === 'No') {
    // console.log('no pregnancy concerns');
  } else {
    for (let i = 0; i < vitaminOptions.length; i++) {
      if (vitaminOptions[i].value == "vitamin-a") {
        vitaminOptions.splice(i, 1);
      }
      if (vitaminOptions[i].value == "5-htp") {
        vitaminOptions.splice(i, 1);
      }
    }
  }

  // If the user said yes to anti depressant medication,
  // remove 5-HTP option
  if (props.medicationAnswer === 'yes') {
    for (let i = 0; i < vitaminOptions.length; i++) {
      if (vitaminOptions[i].value == "5-htp") {
        vitaminOptions.splice(i, 1);
      }
      if (vitaminOptions[i].value == "iodine") {
        vitaminOptions.splice(i, 1);
      }
    }
  }
  const hidButton = () => {
    const button = document.querySelector('.show-more-flavours');
    button.style.display = 'none';
  }
  const showMoreFlavours = () => {
    setFlavoursHidden(false);
    hidButton();
  };

  return (
    <div className="kids-quiz__page">

      <div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Antidepressant question explanation"
        >
          <div className="close-modal" onClick={closeModal}><No /></div>
          <div className="modal-copy">
            <p>If you would like to guarantee specific nourishments are included in your personalised vitamin, we have given you the option to select them here.</p>
            <p>Any nourishments you select will be treated as a priority. Our recommended blend will then make up the rest of your 7-layered vitamin, to ensure that your gummy stack is perfectly suited to your mind and body.</p>
          </div>
        </Modal>
      </div>

      <div className="kids-quiz__question">
        <p className="question__title">Are there any specific nourishments we should include in your stack? <span className="open-modal-button" onClick={openModal}><Information /></span></p>
        <Select
          isMulti
          className='vitamin-selector'
          placeholder={'No, I\'d like to see Nourished suggestions'}
          components={animatedComponents}
          onChange={updateVitaminValues}
          options={vitOptions}
          isOptionDisabled={(option) => option.disabled == true || maxVitamins > 6}
          defaultValue={props.selectedVitamins}
        />
        {maxVitamins > 6 ?
          <p>Maximum number of layers selected</p>
          :
          ''
        }
      </div>

      <a href="#goals" className="question-divider question-divider--show">
        <UpArrow />
      </a>

      <div id="goals" className="kids-quiz__question">
        <p className="question__title">Which of the below are your top two priorities in the upcoming months?</p>
        <div className="answers-row--flex">
          {props.renderGoalAnswers}
        </div>
      </div>

      <a href="#coating" className={`question-divider ${props.activeGoalsAnswer.length > 1 ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="coating" className={`kids-quiz__question ${props.activeGoalsAnswer.length > 1 ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <p className="question__title">What flavour would you like on your stack?</p>
        <div className="radio-answers answers-row--5 wide coating-options">


          <input type="radio" name="flavour" id="flavourStrawberry" value="strawberry" onChange={props.selectFlavour} checked={props.flavour === 'strawberry'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--strawberry" htmlFor="flavourStrawberry"><Strawberry />Strawberry</label>

          {/* <input type="radio" name="flavour" id="flavourApple" value="apple" onChange={props.selectFlavour} checked={props.flavour === 'apple'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--apple" htmlFor="flavourApple"><Apple />Green Apple</label> */}

          <input type="radio" name="flavour" id="flavourCola" value="cola" onChange={props.selectFlavour} checked={props.flavour === 'cola'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--cola" htmlFor="flavourCola"><Cola />Cola</label>

          <input type="radio" name="flavour" id="flavourCitrus" value="citrus" onChange={props.selectFlavour} checked={props.flavour === 'citrus'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--citrus" htmlFor="flavourCitrus"><Citrus />Citrus</label>

          <input type="radio" name="flavour" id="flavourPineapple" value="pineapple" onChange={props.selectFlavour} checked={props.flavour === 'pineapple'} />
          <label className="answer-button answer-button__flavour answer-button__flavour--pineapple" htmlFor="flavourPineapple"><Pineapple />Pineapple</label>

          {/* hidden below */}
          <input type="radio" name="flavour" id="flavourBlackcurrant" value="blackcurrant" onChange={props.selectFlavour} checked={props.flavour === 'blackcurrant'} />
          <label className={`answer-button answer-button__flavour answer-button__flavour--blackcurrant ${flavoursHidden ? 'answer-button__flavour--hidden' : ''}`} htmlFor="flavourBlackcurrant"><Blackcurrant />Blackcurrant</label>

          <input type="radio" name="flavour" id="flavourOrange" value="orange" onChange={props.selectFlavour} checked={props.flavour === 'orange'} />
          <label className={`answer-button answer-button__flavour answer-button__flavour--orange ${flavoursHidden ? 'answer-button__flavour--hidden' : ''}`} htmlFor="flavourOrange"><Orange />Orange</label>

          <input type="radio" name="flavour" id="flavourPeach" value="peach" onChange={props.selectFlavour} checked={props.flavour === 'peach'} />
          <label className={`answer-button answer-button__flavour answer-button__flavour--peach ${flavoursHidden ? 'answer-button__flavour--hidden' : ''}`} htmlFor="flavourPeach"><Peach />Peach</label>

          <input type="radio" name="flavour" id="flavourOriginal" value="original" onChange={props.selectFlavour} checked={props.flavour === 'original'} />
          <label className={`answer-button answer-button__flavour answer-button__flavour--original ${flavoursHidden ? 'answer-button__flavour--hidden' : ''}`} htmlFor="flavourOriginal"><Original />Original</label>

          <input type="radio" name="flavour" id="flavourWatermelon" value="watermelon" onChange={props.selectFlavour} checked={props.flavour === 'watermelon'} />
          <label className={`answer-button answer-button__flavour answer-button__flavour--watermelon ${flavoursHidden ? 'answer-button__flavour--hidden' : ''}`} htmlFor="flavourWatermelon"><Watermelon />Watermelon</label>

        </div>
        <div className={`show-more-flavours`} onClick={showMoreFlavours}>
          Show more flavour options < LittleArrow />
        </div>




        <div className={`line-divider ${props.flavour ? 'line-divider--show' : 'line-divider--hidden'}`}></div>

        <div className={`coating-answers radio-answers answers-row--2 kids-quiz__question ${props.flavour ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
          <input type="radio" name="coating" id="coatingSweet" value="sweet" onChange={props.selectCoating} checked={props.coating === 'sweet'} />
          <label className="answer-button" htmlFor="coatingSweet">Sweet</label>

          <input type="radio" name="coating" id="coatingSour" value="sour" onChange={props.selectCoating} checked={props.coating === 'sour'} />
          <label className="answer-button" htmlFor="coatingSour">Sour</label>
        </div>
      </div>

      <a href="#email" className={`question-divider ${props.coating ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="email" className={`kids-quiz__question ${props.coating ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <label>And finally, what is your email address?</label>
        <input onChange={e => props.setEmail(e.target.value)} placeholder="Email address (optional)" value={props.email} />
        <div className="checkbox" onChange={() => props.setConsent(!props.consent)}>
          <input id="email" name="consent" className="checkbox__input" type="checkbox" value="email" />
          <label htmlFor="email" className="checkbox__label">I agree to receive personalised email communications from Nourished based on my answers in this quiz</label>
        </div>
      </div>

      <div className={`next-page ${props.coating ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('5')}>Get results</div>
    </div>
  );
}

export default PageFive;